<template>
  <div class="professional">
    <SameContent>
      <div class="search-box">
        <div class="title">
          认可专业人士查找
        </div>
        <div class="label">
          认证编号:
        </div>
        <input v-model="value" type="text" placeholder="请输入认证编号" class="search-input">
        <div class="search-btn" @click="handleSearch">
          查&nbsp;询
        </div>
        <div class="tip">
          *查询的专业人士信息均由专业人士本土提供，公司不对其真实性、准确性及时效性承担任何责任。
        </div>
      </div>
      <div class="message">
        <div class="title">
          官方认可专业人士
        </div>
        <div class="desc">
          所有可查询到到专业人士均通过索尔塔医疗专业培训，并经过考核获得官方认可证书。在中国内地，建议您选择经认可的专业人士，以保证操作的规划化和您的合法权益。
        </div>
      </div>
      <div class="footer">
        Copyright 2021 索尔塔医疗©️版权所有
      </div>
    </SameContent>
  </div>
</template>

<script>
import SameContent from '@/components/SameContent'
import { queryRecognitionPerson } from '@/api/common'
export default {
  name: 'Professional',
  components: {
    SameContent
  },
  data() {
    return {
      value: ''
    }
  },
  methods: {
    handleSearch() {
      if (!this.value) return
      queryRecognitionPerson(this.value).then(res => {
        let { content, success, errorType } = res.data
        if (success && errorType === '00000000') {
          if (!content) {
            alert('您输入的专业人士信息不存在，谨防假冒。')
          } else {
            this.$router.push({ path: '/professionalResult', query: { code: this.value }})
          }
        } else {
          alert('查询失败，请稍后再试！')
        }
      }).catch(() => {
        alert('查询失败，请稍后再试！')
      })
    }
  }
}
</script>

<style lang="less" scoped>
.professional{
  width: 100%;
  height: 100%;
  position: relative;
  .search-box{
    width: 633px;
    height: 540px;
    background: #FFFFFF;
    box-shadow: 0px 7px 8px 0px #C8D2F0;
    border-radius: 40px;
    position: absolute;
    left: 50%;
    top: 260px;
    transform: translateX(-50%);
    .title{
      font-size: 60px;
      font-family: Hiragino Sans GB;
      font-weight: normal;
      color: #438AF2;
      margin-top: 40px;
      text-align: center;
    }
    .label{
      font-size: 30px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #737579;
      margin-top: 36px;
      margin-left: 38px;
    }
    .search-input{
      display: block;
      width: 570px;
      height: 80px;
      background: #E5F0FE;
      border-radius: 10px;
      box-sizing: border-box;
      padding: 0 26px;
      border: 0;
      margin: 18px auto 0;
      font-size: 0.875rem;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333;
      &::-webkit-input-placeholder {
        /* WebKit browsers */
        color: rgba(67, 137, 242, 0.53);
      }
      &:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: rgba(67, 137, 242, 0.53);
      }
      &::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: rgba(67, 137, 242, 0.53);
      }
      &:-ms-input-placeholder {
        /* Internet Explorer 10+ */
        color: rgba(67, 137, 242, 0.53);
      }
    }
    .search-btn{
      margin: 31px auto 0;
      width: 570px;
      height: 80px;
      line-height: 80px;
      background: #96C1F9;
      box-shadow: 0px 4px 10px 0px rgba(76, 109, 189, 0.55);
      border-radius: 10px;
      font-size: 34px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      text-align: center;
    }
    .tip{
      padding: 0 47px;
      font-size: 22px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #999999;
      margin-top: 30px;
    }
  }
  .message{
    margin: 156px auto 0;
    width: 633px;
    height: 258px;
    background: rgba(229, 240, 254, 0.42);
    box-shadow: 0px 7px 8px 0px #C8D2F0;
    border-radius: 30px;
    .title{
      padding-top: 10px;
      height: 80px;
      line-height: 80px;
      padding-left: 33px;
      font-size: 34px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #4389F2;
    }
    .desc{
      padding: 0 33px;
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4D4E50;
      line-height: 1.4;
    }
  }
  .footer{
    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #2E2E2E;
    width: 100%;
    text-align: center;
    margin: 80px 0 60px 0;
  }
}
</style>
